export default __webpack_public_path__ + "static/media/em_lsleeve_4.203c5bd3.webp";